import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

interface TimeLogChartData {
  date: string;
  minutes: number;
}

interface TimeLogsChartProps {
  data: TimeLogChartData[];
}

const TimeLogsChart: React.FC<TimeLogsChartProps> = ({ data }) => {
  // Custom tooltip to show hours and minutes
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const minutes = payload[0].value;
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;
      const timeDisplay = hours > 0 
        ? `${hours}h ${remainingMinutes > 0 ? `${remainingMinutes}min` : ''}`.trim()
        : `${minutes}min`;
      
      return (
        <div className="dashboard-chart-tooltip">
          <p className="dashboard-chart-tooltip-label">{payload[0].payload.date}</p>
          {payload.map((entry: any, index: number) => (
            <p key={index} className="dashboard-chart-tooltip-value" style={{ color: entry.color }}>
              {entry.name}: {timeDisplay}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="dashboard-chart-wrapper">
      <ResponsiveContainer width="100%" height={400}>
        <LineChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
          <XAxis
            dataKey="date"
            angle={-45}
            textAnchor="end"
            height={80}
            tick={{ fill: '#666666', fontSize: 12 }}
          />
          <YAxis
            tick={{ fill: '#666666', fontSize: 12 }}
            label={{ value: 'Minutes', angle: -90, position: 'insideLeft', fill: '#666666' }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Line 
            type="monotone" 
            dataKey="minutes" 
            stroke="#007bff" 
            strokeWidth={2}
            name="Time Logged"
            dot={{ fill: '#007bff', r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TimeLogsChart;

